/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Metric_CostInputs */

const en_usage_metric_cost = /** @type {(inputs: Usage_Metric_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated Cost`)
};

const fr_usage_metric_cost = /** @type {(inputs: Usage_Metric_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`coût estimé`)
};

const de_usage_metric_cost = /** @type {(inputs: Usage_Metric_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzte Kosten`)
};

const it_usage_metric_cost = /** @type {(inputs: Usage_Metric_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo stimato`)
};

const ru_usage_metric_cost = /** @type {(inputs: Usage_Metric_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ориентировочная стоимость`)
};

const es_usage_metric_cost = /** @type {(inputs: Usage_Metric_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo estimado`)
};

const zh_cn2_usage_metric_cost = /** @type {(inputs: Usage_Metric_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预计成本`)
};

const ja_usage_metric_cost = /** @type {(inputs: Usage_Metric_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推定費用`)
};

const hi_usage_metric_cost = /** @type {(inputs: Usage_Metric_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमानित लागत`)
};

const pt_pt2_usage_metric_cost = /** @type {(inputs: Usage_Metric_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custo estimado`)
};

/**
* | output |
* | --- |
* | "Estimated Cost" |
*
* @param {Usage_Metric_CostInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_metric_cost = /** @type {((inputs?: Usage_Metric_CostInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Metric_CostInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_metric_cost(inputs)
	if (locale === "de") return de_usage_metric_cost(inputs)
	if (locale === "it") return it_usage_metric_cost(inputs)
	if (locale === "ru") return ru_usage_metric_cost(inputs)
	if (locale === "es") return es_usage_metric_cost(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_metric_cost(inputs)
	if (locale === "ja") return ja_usage_metric_cost(inputs)
	if (locale === "hi") return hi_usage_metric_cost(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_metric_cost(inputs)
	return en_usage_metric_cost(inputs)
});